import React, { useState } from 'react';
import axios from 'axios';
import Breadcrumbs from '../../../components/Common/Breadcrumb';
import {
  Row,
  Col,
  Card,
  CardBody,
  Container,
} from 'reactstrap';
import GetRequestComponent from '../../../components/Common/GetRequest';
const GetAllMembershipPlans = () => {
    const [url, setUrl] = useState('');
    const [requestBody, setRequestBody] = useState('');
    const [response, setResponse] = useState(null);
    const [breadcrumbItems] = useState([
      { title: 'Membership', link: '#' },
      { title: 'Available Membership Plans', link: '#' }
    ]);
    const headers=[
      {
        title:'apikey',
        type:'text',
        required:true,
      }
    ]
  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
        <Breadcrumbs
            title="Get Available Membership Plans"
            breadcrumbItems={breadcrumbItems}
          />
          <p>Retrieves a list of all available Membership plans. Fields marked with <span style={{color:"red"}}>*</span> are required</p>
      <GetRequestComponent title="Get All Membership Plans" headers={headers} url='/v2/tp/membership/plans/membership_pack'/>
      </Container>
      </div>
    </React.Fragment>
  )
}

export default GetAllMembershipPlans;